import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Layout as MarketingLayout } from 'src/layouts/marketing';
import HomePage from 'src/pages';
import Error401Page from 'src/pages/401';
import Error404Page from 'src/pages/404';
import Error500Page from 'src/pages/500';
import ContactPage from 'src/pages/contact';
import { authRoutes } from './auth';
import { dashboardRoutes } from './dashboard';
import TermAndCondition from 'src/pages/LinkPages/TermAndCondition';
import PrivacyPolicy from 'src/pages/LinkPages/PrivacyPolicy';
import Disclaimer from 'src/pages/LinkPages/Disclaimer';

export const routes: RouteObject[] = [
  {
    element: (
      <MarketingLayout>
        <Outlet />
      </MarketingLayout>
    ),
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'term-condition',
        element: <TermAndCondition />
      },
      {
        path: 'disclaimer',
        element: <Disclaimer />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicy />
      },
    ]
  },
  ...authRoutes,
  ...dashboardRoutes,
  {
    path: 'contact',
    element: <ContactPage />
  },
  {
    path: 'term-condition',
    element: <TermAndCondition />
  },
  {
    path: '401',
    element: <Error401Page />
  },
  {
    path: '404',
    element: <Error404Page />
  },
  {
    path: '500',
    element: <Error500Page />
  },

  {
    path: '*',
    element: <Error404Page />
  }
];
